import useProps, { IHookProps } from "./props";

export { useProps, IHookProps };
